module.exports = self["Vue"];